var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.appStyle)},[(_vm.isLoading)?_c('the-app-loader',{attrs:{"data-test":"loading"}}):(_vm.error)?_c('the-app-error',{attrs:{"error":_vm.error,"data-test":"error"}}):_c('router-view',{attrs:{"data-test":"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }